import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
	MatLegacyDialogModule
} from '@angular/material/legacy-dialog';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

interface InfoDialogData {
	infoStatus: string;
}

@Component({
	selector: 'copo-forgot-info-dialog',
	templateUrl: './forgot-info.component.html',
	styleUrls: ['./forgot-info.component.css'],
	encapsulation: ViewEncapsulation.Emulated,
	standalone: true,
	imports: [
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyDialogModule,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyButtonModule,
		TranslateModule,
		NgIf,
		NgSwitch,
		NgSwitchCase,
	],
})
export class ForgotPasswordDialogComponent {
	infoStatus: string;
	constructor(
		// eslint-disable-next-line deprecation/deprecation
		public dialogRef: MatDialogRef<ForgotPasswordDialogComponent>,
		// eslint-disable-next-line deprecation/deprecation
		@Inject(MAT_DIALOG_DATA) public data: InfoDialogData
	) {
		this.infoStatus = data.infoStatus;
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
